import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudgetStep4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 541 384",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M540.012 334.992H0.0117188V335.262H540.012V334.992Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M485.903 352.369H450.134V352.639H485.903V352.369Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M357.729 355.308H348.344V355.578H357.729V355.308Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M449.054 342.348H428.329V342.618H449.054V342.348Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.314 344.162H56.6689V344.432H103.314V344.162Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.773 344.162H112.937V344.432H119.773V344.162Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.173 348.719H141.999V348.989H243.173V348.719Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.533 8.46484H74.0459V250.45H219.533V8.46484Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.127 3.49707H64.6279C64.244 3.49707 63.8759 3.64954 63.6045 3.92095C63.3331 4.19235 63.1807 4.56045 63.1807 4.94427C63.1835 5.32622 63.3372 5.69155 63.6083 5.96062C63.8794 6.22969 64.2459 6.38067 64.6279 6.38066H235.127C235.502 6.36949 235.857 6.21357 236.119 5.94569C236.381 5.67782 236.529 5.31885 236.531 4.94427C236.532 4.56782 236.385 4.20611 236.123 3.93592C235.861 3.66572 235.504 3.50831 235.127 3.49707Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.71 8.46484H76.9297V250.45H225.71V8.46484Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M219.533 250.45H74.0459V254.543H223.788L219.533 250.45Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.992 250.45H87.2109L91.4661 254.543H240.247L235.992 250.45Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.07 241.81V17.1055L85.5803 17.1055V241.81H217.07Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.421 241.81L166.149 17.1055H190.092L139.364 241.81H115.421Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.516 241.81L195.232 17.1055H204.574L153.847 241.81H144.516Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.07 241.81V17.1055H215.969V241.81H217.07Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M85.6665 0.916016H70.7949V220.577H85.6665V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M91.4663 0.916016H79.8779V220.577H91.4663V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M100.538 0.916016H85.666V220.577H100.538V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M106.337 0.916016H94.749V220.577H106.337V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M115.42 0.916016H100.549V220.577H115.42V0.916016Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M211.529 0.916016H202.954V220.577H211.529V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M214.867 0.916016H208.192V220.577H214.867V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M220.104 0.916016H211.529V220.577H220.104V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M223.431 0.916016H216.757V220.577H223.431V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M228.669 0.916016H220.094V220.577H228.669V0.916016Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.136 8.46484H307.649V250.45H453.136V8.46484Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M468.732 3.49707H298.232C297.849 3.49707 297.48 3.64954 297.209 3.92095C296.938 4.19235 296.785 4.56045 296.785 4.94427C296.788 5.32622 296.942 5.69155 297.213 5.96062C297.484 6.22969 297.85 6.38067 298.232 6.38066H468.732C469.114 6.38067 469.48 6.22969 469.751 5.96062C470.023 5.69155 470.176 5.32622 470.179 4.94427C470.179 4.56045 470.027 4.19235 469.755 3.92095C469.484 3.64954 469.116 3.49707 468.732 3.49707Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M459.314 8.46484H310.533V250.45H459.314V8.46484Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M453.136 250.45H307.649V254.543H457.391L453.136 250.45Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M469.595 250.45H320.814L325.07 254.543H473.85L469.595 250.45Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.674 241.81V17.1055L319.184 17.1055V241.81H450.674Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M349.024 241.81L399.752 17.1055H423.696L372.968 241.81H349.024Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M378.109 241.81L428.837 17.1055H438.179L387.451 241.81H378.109Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M450.663 241.821V17.1162H449.561V241.821H450.663Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M319.27 0.916016H304.398V220.577H319.27V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M325.07 0.916016H313.481V220.577H325.07V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M334.141 0.916016H319.27V220.577H334.141V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M339.941 0.916016H328.353V220.577H339.941V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M349.024 0.916016H334.152V220.577H349.024V0.916016Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .4,
			children: [
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M445.134 0.916016H436.559V220.577H445.134V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M448.461 0.916016H441.786V220.577H448.461V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M453.709 0.916016H445.134V220.577H453.709V0.916016Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M457.036 0.916016H450.361V220.577H457.036V0.916016Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M462.273 0.916016H453.698V220.577H462.273V0.916016Z",
					fill: "#F0F0F0"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M466.053 276.489H456.128V334.993H466.053V276.489Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M468.699 276.489H462.856V334.993H468.699V276.489Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M438.784 276.489H428.858V334.993H438.784V276.489Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.641 276.489H434.798V334.993H440.641V276.489Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.606 286.824H470.503V276.489H329.606V286.824Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M301.504 276.489H291.579V334.993H301.504V276.489Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.362 276.489H297.52V334.993H303.362V276.489Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.808 286.824H325.372V276.489H289.808V286.824Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M328.775 276.489H318.85V334.993H328.775V276.489Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M331.421 276.489H325.578V334.993H331.421V276.489Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.065 334.992H137.269V281.867H103.065V334.992Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M212.599 281.867H137.269V334.992H212.599V281.867Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .7,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M103.076 289.924H212.955V287.116H103.076V289.924Z",
				fill: "#E6E6E6"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.175 288.293H137.269V280.161H101.175V288.293Z",
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.478 280.172H137.269V288.304H214.478V280.172Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.729 318.193C265.86 306.977 258.496 296.157 247.28 294.026C236.064 291.895 225.245 299.259 223.113 310.474C220.982 321.69 228.346 332.51 239.562 334.641C250.777 336.773 261.597 329.409 263.729 318.193Z",
			fill: "#E0E0E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M233.951 310.228C232.181 307.651 229.687 305.656 226.783 304.495C223.88 303.335 220.697 303.061 217.638 303.71C214.579 304.358 211.781 305.898 209.598 308.136C207.415 310.375 205.944 313.21 205.372 316.284C204.799 319.358 205.151 322.532 206.383 325.406C207.615 328.28 209.671 330.724 212.292 332.43C214.913 334.135 217.98 335.025 221.107 334.987C224.234 334.95 227.279 333.986 229.858 332.217C231.571 331.043 233.035 329.542 234.168 327.801C235.301 326.06 236.08 324.113 236.46 322.071C236.84 320.029 236.814 317.932 236.384 315.9C235.953 313.868 235.126 311.941 233.951 310.228Z",
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.012 383.765C385.661 383.765 479.413 378.291 479.413 371.539C479.413 364.787 385.661 359.313 270.012 359.313C154.362 359.313 60.6104 364.787 60.6104 371.539C60.6104 378.291 154.362 383.765 270.012 383.765Z",
			fill: "#F5F5F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.28 49.7963C246.5 48.6407 241.813 55.4447 238.93 63.0695C236.046 70.6943 231.283 72.0011 226.186 75.0575C235.603 88.2335 257.56 85.4795 264.86 83.8163C272.161 82.1531 278.695 87.9635 288.016 81.1271C296.364 75.0035 295.748 56.7623 281.006 48.4463C284.268 37.2467 250.637 36.1235 250.28 49.7963Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.251 164.103H279.883C279.039 164.124 278.201 163.956 277.429 163.611C276.658 163.267 275.974 162.755 275.425 162.112C274.877 161.47 274.479 160.713 274.26 159.897C274.041 159.082 274.006 158.227 274.159 157.397L275.326 149.48C275.636 147.647 276.572 145.977 277.973 144.754C279.375 143.532 281.156 142.832 283.015 142.773H293.372C294.217 142.751 295.057 142.918 295.829 143.262C296.601 143.606 297.286 144.118 297.835 144.761C298.384 145.404 298.782 146.161 299 146.978C299.218 147.794 299.251 148.649 299.096 149.48L297.941 157.44C297.617 159.264 296.677 160.921 295.277 162.134C293.877 163.348 292.103 164.043 290.251 164.103Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M290.251 164.373H279.883C279.01 164.391 278.144 164.217 277.346 163.865C276.547 163.512 275.836 162.989 275.261 162.332C274.682 161.653 274.261 160.855 274.026 159.994C273.79 159.134 273.748 158.232 273.9 157.353L275.055 149.437C275.376 147.539 276.345 145.812 277.796 144.548C279.247 143.284 281.091 142.561 283.015 142.503H293.372C294.246 142.485 295.112 142.657 295.913 143.008C296.713 143.358 297.427 143.879 298.005 144.534C298.58 145.215 299 146.013 299.235 146.873C299.47 147.733 299.515 148.634 299.366 149.512L298.2 157.44C297.881 159.336 296.915 161.064 295.465 162.328C294.016 163.592 292.173 164.315 290.251 164.373ZM282.972 143.043C281.176 143.099 279.456 143.775 278.103 144.956C276.75 146.138 275.849 147.752 275.552 149.523L274.429 157.44C274.293 158.242 274.333 159.065 274.548 159.85C274.762 160.636 275.146 161.365 275.671 161.986C276.193 162.587 276.841 163.065 277.569 163.387C278.297 163.708 279.087 163.864 279.883 163.844H290.251C292.046 163.789 293.767 163.113 295.12 161.931C296.473 160.75 297.374 159.136 297.671 157.364L298.826 149.448C298.966 148.646 298.928 147.823 298.716 147.038C298.503 146.252 298.12 145.523 297.595 144.901C297.071 144.301 296.421 143.824 295.691 143.504C294.96 143.185 294.169 143.031 293.372 143.054L282.972 143.043Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M297.433 153.033H297.379C297.345 153.026 297.312 153.011 297.282 152.991C297.253 152.97 297.228 152.944 297.209 152.914C297.19 152.884 297.177 152.85 297.171 152.815C297.165 152.78 297.166 152.744 297.174 152.709C298.071 148.519 297.941 146.596 294.798 145.592C294.764 145.581 294.733 145.563 294.706 145.539C294.678 145.516 294.656 145.487 294.64 145.455C294.624 145.423 294.615 145.388 294.612 145.352C294.609 145.316 294.614 145.28 294.625 145.246C294.637 145.212 294.655 145.181 294.678 145.154C294.702 145.127 294.73 145.104 294.762 145.088C294.794 145.072 294.829 145.063 294.865 145.06C294.901 145.058 294.937 145.062 294.971 145.074C298.783 146.305 298.513 149.059 297.703 152.828C297.687 152.887 297.652 152.939 297.603 152.976C297.554 153.013 297.495 153.033 297.433 153.033Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.949 43.3379L335.104 24.5459L376.122 56.2547L357.968 75.0575L316.949 43.3379Z",
			fill: "#F0C700"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M336.151 23.4658L335.104 24.5458L376.122 56.2546L378.606 47.431L336.151 23.4658Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.694 37.4519C320.037 35.6483 318.309 33.4343 317.942 31.3715C317.837 30.8783 317.834 30.3687 317.935 29.8744C318.035 29.3801 318.236 28.9119 318.525 28.4987C321.495 24.3731 325.265 26.9327 329.25 29.6435L329.779 29.9999L329.487 30.4211L328.958 30.0647C325.027 27.3863 321.625 25.0643 318.936 28.7903C318.69 29.1498 318.52 29.555 318.435 29.9818C318.349 30.4085 318.351 30.8481 318.439 31.2743C318.785 33.2075 320.437 35.3135 322.986 37.0307L322.694 37.4519Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.877 94.3356L301.332 82.7256L309.086 76.9152L310.976 75.4896L311.916 74.7876L312.369 74.442L312.596 74.2476C313.481 73.3935 314.25 72.4278 314.886 71.3748C316.35 68.8752 317.504 66.2058 318.32 63.426C319.198 60.4637 319.919 57.4571 320.48 54.4188C321.074 51.33 321.56 48.198 321.884 45.0336C322.208 41.8692 322.554 38.6616 322.759 35.5404V35.454C322.8 34.8333 323.076 34.2515 323.53 33.8265C323.984 33.4015 324.583 33.165 325.205 33.165C325.827 33.165 326.426 33.4015 326.88 33.8265C327.334 34.2515 327.61 34.8333 327.651 35.454C328.205 42.1074 328.177 48.7965 327.565 55.4448C327.267 58.8431 326.736 62.2169 325.977 65.5428C325.209 69.0732 323.978 72.4867 322.316 75.6948C321.375 77.4904 320.186 79.1446 318.785 80.6088L318.137 81.2352L317.64 81.6672L316.689 82.488L314.778 84.1296C312.294 86.2464 309.774 88.3344 307.218 90.3936L299.528 96.4848C296.914 98.4612 294.333 100.438 291.623 102.349C290.56 103.045 289.271 103.305 288.022 103.076C286.772 102.847 285.659 102.147 284.912 101.119C284.166 100.092 283.843 98.8173 284.01 97.5584C284.177 96.2996 284.823 95.1534 285.812 94.3572L285.877 94.3356Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.846 38.068L314.411 34.1044L323.127 29.5576C323.127 29.5576 329.866 33.0028 327.706 37.9168L322.846 38.068Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M312.64 28.3044L320.146 24.8916L323.126 29.5572L314.411 34.104L312.64 28.3044Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M295.738 98.7532C295.889 105.762 294.906 120.353 289.982 150.593H250.724C251.382 134.62 252.16 124.608 244.524 91.8196C249.769 90.7419 255.086 90.0596 260.433 89.7784C266.369 89.3512 272.328 89.3512 278.264 89.7784C282.098 90.124 286.202 90.7504 289.334 91.2796C291.104 91.5859 292.712 92.4997 293.881 93.8639C295.05 95.228 295.707 96.957 295.738 98.7532Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.852 145.56C294.779 145.55 294.714 145.511 294.669 145.452C294.625 145.394 294.605 145.32 294.615 145.247C298.189 120.72 262.452 94.0552 254.892 90.4804C254.856 90.4684 254.823 90.4489 254.795 90.4232C254.767 90.3974 254.744 90.366 254.729 90.331C254.714 90.296 254.706 90.2582 254.707 90.2201C254.708 90.182 254.716 90.1445 254.732 90.1099C254.748 90.0754 254.772 90.0446 254.801 90.0197C254.829 89.9948 254.863 89.9763 254.9 89.9654C254.936 89.9545 254.975 89.9514 255.012 89.9564C255.05 89.9614 255.087 89.9744 255.119 89.9944C259.612 92.1544 270.541 99.9304 279.732 109.996C287.843 118.863 297.099 132.19 295.187 145.355C295.169 145.426 295.124 145.488 295.061 145.526C294.999 145.564 294.924 145.577 294.852 145.56Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.204 69.7334C263.284 75.4682 264.45 85.9334 260.433 89.8106C264.938 94.5725 270.37 98.3618 276.395 100.945C284.063 96.1394 278.263 89.8106 278.263 89.8106C271.87 88.277 272.032 83.5358 273.144 79.0754L262.204 69.7334Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M266.664 73.5459L273.144 79.0755C272.868 80.1122 272.684 81.171 272.593 82.2399C270.152 81.8835 266.793 79.2051 266.534 76.6455C266.39 75.6129 266.434 74.5628 266.664 73.5459Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M255.389 62.4005C259.158 71.2133 260.573 75.0365 266.772 78.0389C276.114 82.5533 286.126 75.9977 285.057 66.2237C284.106 57.4325 278.101 44.4833 267.993 44.0405C265.764 43.9333 263.545 44.3977 261.546 45.3894C259.547 46.3812 257.835 47.8674 256.572 49.7069C255.31 51.5464 254.538 53.6783 254.331 55.8999C254.124 58.1215 254.488 60.3592 255.389 62.4005Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266.459 48.8571C268.619 54.1383 260.162 64.4739 254.093 68.5347C246.36 52.4427 250.961 45.7575 266.459 48.8571Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M273.404 43.5435C283.847 46.2003 258.554 54.9807 251.264 55.4235C258.824 43.0467 263.597 40.3467 273.404 43.5435Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.982 150.625C289.982 150.625 286.601 221.333 286.925 250.817C287.26 281.489 267.14 358.46 267.14 358.46L259.396 356.3C259.396 356.3 263.122 293.66 266.783 250.903C261.254 218.071 258.197 150.582 258.197 150.582L289.982 150.625Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266.513 356.689L259.299 355.015C259.114 354.971 258.92 354.994 258.751 355.081C258.582 355.169 258.451 355.314 258.381 355.49L255.432 362.694C255.36 362.903 255.333 363.125 255.351 363.345C255.37 363.565 255.435 363.779 255.542 363.973C255.649 364.166 255.796 364.335 255.972 364.468C256.149 364.602 256.351 364.696 256.566 364.746C260.303 365.545 260.562 365.372 265.206 366.463C268.101 367.133 273.09 369.552 277.184 369.552C281.277 369.552 280.51 365.686 278.793 365.383C272.583 364.249 272.313 362.046 267.906 357.64C267.536 357.203 267.055 356.875 266.513 356.689Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.732 150.625C279.732 150.625 258.056 252.221 252.883 261.995C245.906 275.192 180.75 256.476 178.525 256.519L178.201 249.834C178.201 249.834 210.288 249.099 236.878 250.428C236.878 217.131 250.734 150.625 250.734 150.625H279.732Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.422 256.432L184.26 250.816C184.385 250.675 184.453 250.492 184.453 250.303C184.453 250.115 184.385 249.932 184.26 249.79L179.292 243.84C179.141 243.677 178.958 243.549 178.754 243.462C178.55 243.376 178.33 243.334 178.108 243.339C177.887 243.344 177.669 243.396 177.469 243.492C177.269 243.588 177.092 243.724 176.949 243.894C174.508 246.82 174.54 247.134 171.387 250.784C169.453 253.03 168.039 254.91 165.155 257.804C162.271 260.698 165.015 263.766 166.44 262.772C171.624 259.154 171.959 259.176 177.931 257.286C178.496 257.14 179.011 256.846 179.422 256.432Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.012 60.0351C270.271 60.7695 270.876 61.2231 271.351 61.0611C271.826 60.8991 272.01 60.1539 271.751 59.4195C271.492 58.6851 270.887 58.2207 270.401 58.3935C269.915 58.5663 269.71 59.3007 270.012 60.0351Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.263 57.0754C278.533 57.8098 279.127 58.2635 279.613 58.0907C280.099 57.9178 280.272 57.1942 280.002 56.4598C279.732 55.7254 279.138 55.261 278.663 55.3798C278.188 55.4986 278.004 56.341 278.263 57.0754Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M278.469 55.5527L280.046 54.4727C280.046 54.4727 279.635 56.1143 278.469 55.5527Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.492 59.1602C277.753 60.6051 279.207 61.8698 280.812 62.9185C280.534 63.3198 280.171 63.6553 279.75 63.9016C279.328 64.1478 278.858 64.2989 278.371 64.3441L276.492 59.1602Z",
			fill: "#ED847E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275.553 68.4483C275.981 68.3669 276.403 68.255 276.816 68.1135C276.873 68.0935 276.92 68.0515 276.947 67.9968C276.973 67.9421 276.977 67.8792 276.957 67.8219C276.936 67.7646 276.895 67.7177 276.84 67.6913C276.785 67.665 276.722 67.6615 276.665 67.6815C275.76 68.0311 274.784 68.1606 273.819 68.0592C272.854 67.9578 271.927 67.6285 271.114 67.0983C271.09 67.0799 271.062 67.0664 271.033 67.0586C271.003 67.0508 270.973 67.0488 270.943 67.0528C270.913 67.0568 270.884 67.0667 270.857 67.0819C270.831 67.0972 270.808 67.1174 270.79 67.1415C270.771 67.1656 270.758 67.1931 270.75 67.2225C270.742 67.2518 270.74 67.2824 270.744 67.3125C270.748 67.3425 270.758 67.3715 270.773 67.3978C270.789 67.4241 270.809 67.4471 270.833 67.4655C272.219 68.3943 273.911 68.7468 275.553 68.4483Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M254.99 67.8541C255.966 69.4129 257.519 70.523 259.31 70.9429C261.707 71.4721 262.766 69.2905 261.988 67.0981C261.275 65.1217 259.18 62.4757 256.826 62.9293C256.317 63.0449 255.846 63.2852 255.453 63.6286C255.061 63.9719 254.76 64.4074 254.578 64.896C254.396 65.3845 254.338 65.9107 254.41 66.4271C254.482 66.9434 254.681 67.4339 254.99 67.8541Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M261.685 71.6121C261.685 72.0394 261.559 72.457 261.321 72.8122C261.084 73.1674 260.747 73.4442 260.352 73.6077C259.957 73.7712 259.523 73.814 259.104 73.7307C258.685 73.6473 258.3 73.4416 257.998 73.1395C257.696 72.8374 257.49 72.4525 257.407 72.0335C257.323 71.6145 257.366 71.1802 257.53 70.7856C257.693 70.3909 257.97 70.0535 258.325 69.8162C258.68 69.5788 259.098 69.4521 259.525 69.4521C260.098 69.4521 260.647 69.6797 261.053 70.0848C261.458 70.4899 261.685 71.0393 261.685 71.6121Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M267.323 56.9356C267.445 56.904 267.549 56.8266 267.615 56.7196C267.879 56.2091 268.258 55.7674 268.723 55.4298C269.188 55.0923 269.726 54.8682 270.293 54.7756C270.353 54.7715 270.411 54.7557 270.465 54.729C270.518 54.7023 270.566 54.6653 270.605 54.6202C270.644 54.575 270.674 54.5226 270.693 54.4658C270.711 54.4091 270.719 54.3492 270.714 54.2896C270.71 54.23 270.695 54.1718 270.668 54.1183C270.641 54.0648 270.604 54.0171 270.559 53.978C270.514 53.9389 270.461 53.909 270.405 53.8902C270.348 53.8714 270.288 53.864 270.228 53.8684C269.506 53.9654 268.818 54.2349 268.222 54.6541C267.626 55.0733 267.14 55.6299 266.805 56.2768C266.776 56.3293 266.759 56.3868 266.752 56.4462C266.746 56.5056 266.752 56.5655 266.769 56.6227C266.786 56.6799 266.814 56.7332 266.852 56.7795C266.889 56.8257 266.936 56.8641 266.988 56.8924C267.038 56.923 267.093 56.9426 267.151 56.95C267.209 56.9575 267.268 56.9526 267.323 56.9356Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M280.812 51.7836C280.911 51.727 280.985 51.6341 281.017 51.5244C281.036 51.467 281.042 51.4065 281.037 51.3465C281.032 51.2865 281.014 51.2281 280.986 51.1748C280.958 51.1215 280.92 51.0744 280.873 51.0361C280.826 50.9979 280.773 50.9693 280.715 50.9521C280.023 50.728 279.287 50.6728 278.569 50.7912C277.852 50.9096 277.173 51.198 276.589 51.6324C276.533 51.6678 276.485 51.7149 276.448 51.7705C276.412 51.8261 276.388 51.8888 276.378 51.9545C276.367 52.0202 276.371 52.0874 276.389 52.1514C276.407 52.2154 276.439 52.2748 276.482 52.3256C276.525 52.3763 276.578 52.4173 276.638 52.4456C276.699 52.474 276.764 52.4891 276.831 52.49C276.897 52.4908 276.963 52.4773 277.024 52.4505C277.085 52.4237 277.139 52.3841 277.183 52.3344C277.645 51.9998 278.179 51.7794 278.742 51.6912C279.305 51.6029 279.882 51.6494 280.423 51.8268C280.487 51.8477 280.555 51.8546 280.622 51.8471C280.689 51.8397 280.754 51.818 280.812 51.7836Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M270.163 58.5119L271.751 57.3779C271.751 57.3779 271.329 59.0735 270.163 58.5119Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.981 150.625L288.782 240.438L236.348 229.8C234.188 187.215 239.88 162.44 250.723 150.614L289.981 150.625Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M289.852 152.763L250 151.478C249.914 151.475 249.829 151.452 249.753 151.411C249.677 151.371 249.611 151.314 249.561 151.244C249.51 151.174 249.475 151.094 249.46 151.009C249.444 150.925 249.448 150.837 249.471 150.754L250.075 148.594C250.109 148.473 250.183 148.366 250.285 148.292C250.387 148.217 250.511 148.179 250.637 148.184L289.949 149.469C290.099 149.475 290.241 149.539 290.344 149.648C290.447 149.757 290.503 149.902 290.5 150.052L290.435 152.212C290.429 152.362 290.365 152.504 290.256 152.607C290.147 152.71 290.002 152.766 289.852 152.763Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M278.339 214.453L266.901 193.447L268.316 174.623L278.339 214.453Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.424 100.924C243.022 95.4265 239.944 89.9293 237.05 84.1945C234.059 78.4431 231.486 72.4841 229.35 66.3637C228.82 64.7869 228.345 63.1237 227.935 61.4821C227.719 60.6505 227.546 59.7757 227.384 58.9009L227.028 56.4709C226.617 53.2309 226.272 50.1637 225.948 47.0209C225.386 40.7353 224.954 34.4605 224.77 28.1533C224.754 27.5471 224.961 26.9561 225.353 26.4935C225.745 26.0308 226.294 25.7291 226.895 25.6462C227.496 25.5633 228.106 25.7049 228.609 26.0439C229.112 26.383 229.471 26.8957 229.62 27.4837C231.121 33.5965 232.428 39.7309 233.713 45.8437L235.603 54.9589L236.089 57.1189C236.262 57.7669 236.424 58.4257 236.629 59.1061C237.028 60.4561 237.504 61.8169 238.044 63.1993C239.124 65.9425 240.322 68.7073 241.629 71.4397C242.936 74.1721 244.308 76.9153 245.744 79.6261C248.638 85.0261 251.695 90.4261 254.794 95.6749V95.7397C255.475 96.8596 255.682 98.204 255.371 99.4769C255.06 100.75 254.257 101.847 253.137 102.527C252.017 103.208 250.672 103.415 249.399 103.104C248.126 102.793 247.029 101.99 246.349 100.87L246.424 100.924Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.637 30.3027L237.925 25.5399L228.864 21.7383C228.864 21.7383 224.004 25.5939 224.717 29.5575L228.637 30.3027Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M241.339 18.1632L233.584 15.3984L227.709 22.8072L237.926 25.5396L241.339 18.1632Z",
			fill: "#FFC3BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M192.017 29.4974L188.35 31.7803L188.92 32.6972L192.588 30.4143L192.017 29.4974Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.178 22.5468L195.421 27.375L195.992 28.2919L203.749 23.4637L203.178 22.5468Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.712 17.332L238.195 34.7848L194.423 69.172L177.046 43.252L218.712 17.332Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239.308 35.7886L238.195 34.7842L194.423 69.1714L204.434 73.5454L239.308 35.7886Z",
			fill: "#F0C700"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.03 23.2612C224.993 23.2608 224.956 23.2519 224.922 23.235C224.888 23.2182 224.859 23.1939 224.836 23.164C224.812 23.1399 224.793 23.1113 224.78 23.0798C224.766 23.0483 224.76 23.0145 224.76 22.9804C224.76 22.9463 224.766 22.9125 224.78 22.881C224.793 22.8495 224.812 22.8209 224.836 22.7968C226.996 20.9284 228.627 19.4488 230.506 18.9088C230.539 18.8988 230.573 18.8954 230.607 18.8987C230.641 18.9019 230.674 18.9119 230.704 18.928C230.734 18.944 230.761 18.9658 230.782 18.9922C230.804 19.0186 230.82 19.049 230.83 19.0816C230.84 19.1142 230.843 19.1485 230.84 19.1825C230.837 19.2164 230.827 19.2494 230.811 19.2795C230.795 19.3096 230.773 19.3362 230.747 19.3579C230.72 19.3795 230.69 19.3957 230.657 19.4056C228.886 19.9132 227.244 21.3604 225.182 23.1856C225.143 23.2294 225.089 23.2565 225.03 23.2612Z",
			fill: "#263238"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M232.32 29.7845C232.284 29.784 232.248 29.7761 232.214 29.7612C232.181 29.7464 232.151 29.7249 232.126 29.6981C232.102 29.674 232.083 29.6454 232.07 29.6139C232.057 29.5824 232.05 29.5486 232.05 29.5145C232.05 29.4804 232.057 29.4466 232.07 29.4151C232.083 29.3836 232.102 29.355 232.126 29.3309C234.869 26.9009 236.586 24.7625 237.083 23.1533C237.106 23.0865 237.153 23.0311 237.216 22.9988C237.278 22.9665 237.351 22.96 237.418 22.9805C237.482 23.0027 237.536 23.0485 237.568 23.1086C237.6 23.1687 237.608 23.2386 237.591 23.3045C237.051 25.0325 235.334 27.1925 232.472 29.7197C232.429 29.7565 232.376 29.7791 232.32 29.7845Z",
			fill: "#263238"
		})
	]
});
const ForwardRef = forwardRef(SvgBudgetStep4);
export default ForwardRef;
